import React from 'react'
import { useIsMobile } from '@yes.technology/react-toolkit'
import AreaLineTitle from './AreaLineTitle'

const LeftHeaderElement = () => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return null
  }

  return <AreaLineTitle />
}

export default LeftHeaderElement
